import { SxProps, Theme } from "@mui/material";

export const styles: Record<string, SxProps<Theme>> = {
  dialogContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
  },
  title: {
    fontSize: "1.25rem",
    lineHeight: "1.625rem",
    fontWeight: 700,
  },
  description: {
    fontSize: "1rem",
    lineHeight: "1rem",
    fontWeight: 500,
  },
  buttonContainer: {
    display: "flex",
    gap: "1rem",
  },
  cancelButton: {
    flexBasis: "50%",
  },
  deleteButton: {
    background: "#FFF",
    color: "inherit",
    border: "1px solid #E5E5E5",
    flexBasis: "50%",
  },
};
